<div class="wrapper">
    <ul>
        <li>
            <span
                >{{ order?.customer?.firstname }}
                {{ order?.customer?.surname }}</span
            ><span>Lorem ipsum</span>
        </li>
        <li><span>Subject</span><span>Lorem ipsum</span></li>
    </ul>
    <div class="filler"></div>
    <div class="order-footer">
        <div class="order-id">#{{order.publicId}}</div>
        <div class="created-at">
            Created {{ order.createdAt | date: "dd/MM/YYYY" }}
        </div>
        <div class="filler"></div>
        <app-user-avatar
            [firstname]="order.customer.firstname"
            [lastname]="order.customer.surname"
        ></app-user-avatar>
    </div>
</div>
